import React from "react";
import { useTheme } from "../theme/ThemeProvider";

function WomButton({
  children,
  size = "md",
  variant = "primary",
  disabled = false,
  iconLeft = null,
  iconRight = null,
  style = {},
  onClick,
}) {
  const t = useTheme();

  const sizes = {
    sm: {
      padding: `${t.spacing.xs} ${t.spacing.sm}`,
      fontSize: 13,
      height: 34,
    },
    md: {
      padding: `${t.spacing.sm} ${t.spacing.md}`,
      fontSize: 14,
      height: 40,
    },
    lg: {
      padding: `${t.spacing.md} ${t.spacing.lg}`,
      fontSize: 16,
      height: 48,
    },
  };

    const variants = {
    primary: {
      background: t.colors.primary,
      color: "#fff",
      border: "none",
    },
    outline: {
      background: "transparent",
      color: t.colors.textPrimary,
      border: `1px solid ${t.colors.borderStrong}`,
    },
    subtle: {
      background: t.colors.bgSubtle,
      color: t.colors.textSecondary,
      border: "none",
    },
    ghost: {
      background: "transparent",
      color: t.colors.textSecondary,
      border: "none",
    },
    darkPill: {
      background: "rgba(15,23,42,0.95)",
      color: "#e5e7eb",
      border: `1px solid ${t.colors.borderStrong}`,
      borderRadius: 9999,
    },
  };


  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{
        borderRadius: t.radius.md,
        cursor: disabled ? "default" : "pointer",
        display: "flex",
        alignItems: "center",
        gap: 8,
        opacity: disabled ? 0.5 : 1,
        transition: "0.2s",
        ...sizes[size],
        ...variants[variant],
        ...style,
      }}
    >
      {iconLeft && <span>{iconLeft}</span>}
      <span>{children}</span>
      {iconRight && <span>{iconRight}</span>}
    </button>
  );
}

export default WomButton;
export { WomButton };
